import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { apiGetModulesList } from "../api/apiCommands"

export const getModulesState = createAsyncThunk(
  'modules/getModulesState',
  async ({token, url}) => {
    return apiGetModulesList(token, url)
  }
)

const initialState = {
  totalItems: 0,
  filteredItems: 0,
  items: [],
  status: null,
  error: null
}

const modulesSlice = createSlice({
  name: 'modules',

  initialState,

  reducers: {
      setNewStatus(state, action) {
        state.status = action.payload
      },

      nullifyModules(state) {
        state.totalItems = initialState.totalItems
        state.filteredItems = initialState.filteredItems
        state.items = initialState.items
        state.status = initialState.status
        state.error = initialState.error
      }
    },

    extraReducers: {
      [getModulesState.pending]: (state) => {
        state.status = 'loading'
      },

      [getModulesState.fulfilled]: (state, action) => {
        const response = action.payload

        state.items = response.items
        state.totalItems = response.totalItems
        state.filteredItems = response.filteredItems
        state.status = 'success'
        state.error = null
      },

      [getModulesState.rejected]: (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      },
    }
})

export default modulesSlice.reducer
export const { setNewStatus, nullifyModules } = modulesSlice.actions
